import React, { useEffect, useMemo, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import HamlSnippet from "../../components/globals/HamlSnippet";

function ProductVariantRulesPage({ match }) {

  return (
    <Container
          location={{
            locationName: "Product Variant Rules",
            locationUrl: match.url,
          }}
        >
        <HamlSnippet url="/front/products/product_variant_rules" />
    </Container>
  );
}

export default ProductVariantRulesPage;